const hospitalData = [
  {
    state: 'kano',
    hospital: [
      {
        name: 'Murtala Muhammad Specialist Hospital (Waraka SARC)',
        address: 'Kofar Nassarawa, Kano Municipal, Kano',
        phone: '08031234567'
      },
      {
        name: 'Sir Muhammadu Sunusi Specialist Hospital (SARC)',
        address: 'Yan Kaba, Hadejia Road, Nassarawa, Kano',
        phone: '08039876543'
      },
      {
        name: 'Aminu Kano Teaching Hospital (AKTH)',
        address: 'Zaria Road, Tarauni LGA, Kano',
        phone: '08035551212'
      },
      {
        name: 'Wudil General Hospital Emergency Unit',
        address: 'Maiduguri Road, Wudil LGA, Kano State',
        phone: '08021114455'
      }
    ]
  },
  {
    state: 'kaduna',
    hospital: [
      {
        name: 'Barau Dikko Teaching Hospital (Salama SARC)',
        address: 'Lafia Road, Kaduna North, Kaduna',
        phone: '08029876543'
      },
      {
        name: 'Yusuf Dantsoho Memorial Hospital (Salama SARC)',
        address: 'Tudun Wada, Kaduna South, Kaduna',
        phone: '08021112233'
      },
      {
        name: 'Hajiya Gambo Sawaba General Hospital (Salama SARC)',
        address: 'Kofan Gayan, Zaria, Kaduna',
        phone: '08036001234'
      }
    ]
  },
  {
    state: 'abuja',
    hospital: [
      {
        name: 'Bwari General Hospital (Bwari SARC)',
        address: 'Bwari Town, Abuja FCT',
        phone: '08092222245'
      },
      {
        name: 'National Hospital Abuja Trauma Center',
        address: 'Central Business District, Garki, Abuja FCT',
        phone: '08031230000'
      },
      {
        name: 'Gwarinpa General Hospital Crisis Unit',
        address: '3rd Avenue, Gwarinpa Estate, Abuja FCT',
        phone: '08039870011'
      }
    ]
  },
  {
    state: 'lagos',
    hospital: [
      {
        name: 'Mirabel Centre (LASUTH)',
        address: '1-5 Oba Akinjobi Way, Ikeja, Lagos',
        phone: '08187215396'
      },
      {
        name: 'Alimosho General Hospital SARC Unit',
        address: 'Lasu-Iba Expressway, Igando, Alimosho, Lagos',
        phone: '08033221100'
      },
      {
        name: 'Ikorodu General Hospital',
        address: 'T.O.S Benson Road, Ikorodu, Lagos',
        phone: '08023456789'
      }
    ]
  },
  {
    state: 'jigawa',
    hospital: [
      {
        name: 'Dutse General Hospital SARC',
        address: 'Kiyawa Road, Dutse, Jigawa State',
        phone: '08065554433'
      },
      {
        name: 'Hadejia General Hospital',
        address: 'Hadejia Town, Jigawa State',
        phone: '08034441122'
      }
    ]
  },
  {
    state: 'katsina',
    hospital: [
      {
        name: 'Katsina General Hospital SARC',
        address: 'IBB Way, Katsina Town, Katsina State',
        phone: '08034445566'
      },
      {
        name: 'Daura General Hospital',
        address: 'Daura Town, Katsina State',
        phone: '08027778899'
      }
    ]
  },
  {
    state: 'adamawa',
    hospital: [
      {
        name: 'Hope Center SARC, Specialist Hospital Yola',
        address: 'Lamido Zubairu Way, Jimeta-Yola, Adamawa',
        phone: '08137926904'
      },
      {
        name: 'Federal Medical Centre (FMC) Yola',
        address: 'Lamido Zubairu Way, Bypass, Yola, Adamawa',
        phone: '08028889900'
      }
    ]
  },
  {
    state: 'borno',
    hospital: [
      {
        name: 'Ummu Kulthum SARC, State Specialist Hospital',
        address: 'Shehu Laminu Way, Maiduguri, Borno State',
        phone: '08023334455'
      },
      {
        name: 'University of Maiduguri Teaching Hospital (UMTH)',
        address: 'Bama Road, Maiduguri, Borno State',
        phone: '08031110022'
      }
    ]
  }
];

export default hospitalData;
